import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import {
  companyDetails,
  resetSuperAdminStatus,
  superAdminSubscriptionUpdate,
} from "../../../redux/actions";
import { STATUS } from "../../../redux/constants";
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";

import CeroItemPair from "../../../components/CeroItemPair";
import CeroButton from "../../../components/CeroButton";
import { useSnackbar } from "notistack";
import { updateCompanySubscription } from "../../../redux/actions";
import CeroPopUp from "../../../components/CeroPopUp";
import CloseIcon from "@mui/icons-material/Close";
import CeroSelect from "../../../components/CeroSelect";
import CeroInput from "../../../components/CeroInput";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import CeroUploadedFile from "../../../components/CeroUploadedFile";
import { useNavigate } from "react-router-dom";

const CustomerManagement = (props) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { companyId, companyData, companyName } = props;
  const [editAccessDisabled, setEditAccessDisabled] = useState(
    companyData?.edit_access === true ? true : false
  );
  const [selectedValue, setSelectedValue] = useState(
    companyData?.read_only_access_duration || ""
  );
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [year, setYear] = useState(null);
  const [note, setNote] = useState(null);
  const [actionEffect, setActionEffect] = useState(null);
  const [title, setTitle] = useState(null);
  const [subTitle, setSubTitle] = useState(null);
  const [action, setAction] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSubscriptionPopupOpen, setIsSubscriptionPopupOpen] = useState(false);
  const actionStatus = useSelector(
    (state) => state.superAdmin.updateCompanySubscription
  );

  const updateActionStatus = useSelector(
    (state) => state.superAdmin.superAdminSubscriptionUpdate
  );

  const extendedSub = props?.companyData?.extended_subscription === true;
  const subStatus = props?.companyData?.subscription_status;

  const subDaysLeft = props?.companyData?.days_left;
  const canExtendGrace = !props?.companyData?.is_grace_period_extended;
  const canExtendReadOnly = !props?.companyData?.is_read_only_extended;

  const onEdit = () => {
    if (!editAccessDisabled) {
      setEditAccessDisabled(true);
      const data = {
        disable_edit_access: true,
      };
      dispatch(updateCompanySubscription(companyId, data));
    }
  };

  const readOnlyAccess = (duration) => {
    const data = {
      duration_for_read_only_access: duration,
    };
    dispatch(updateCompanySubscription(companyId, data));
  };

  const handleChange = (event) => {
    const selectedDuration = parseInt(event.target.value);
    setSelectedValue(selectedDuration);
    readOnlyAccess(selectedDuration);
  };

  const extendSubscription = () => {
    const data = {
      extended_subscription: true,
    };
    dispatch(updateCompanySubscription(companyId, data));
  };

  const reactivateSubscription = () => {
    const data = {
      renew: true,
    };
    dispatch(updateCompanySubscription(companyId, data));
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setIsSubscriptionPopupOpen(false);
  };

  useEffect(() => {
    if (actionStatus.status === STATUS.SUCCESS) {
      enqueueSnackbar(actionStatus?.data.message, {
        variant: "success",
        autoHideDuration: 3000,
      });
      dispatch(resetSuperAdminStatus());
      setIsPopupOpen(false);
      dispatch(companyDetails(companyId));
    } else if (actionStatus.status === STATUS.ERROR) {
      enqueueSnackbar(
        actionStatus?.data.message ||
          "We couldn't process your request. Please try again later.",
        { variant: "error", autoHideDuration: 3000 }
      );
      dispatch(resetSuperAdminStatus());
    }
  }, [actionStatus, dispatch, enqueueSnackbar]);

  useEffect(() => {
    if (updateActionStatus.status === STATUS.SUCCESS) {
      enqueueSnackbar(updateActionStatus?.data.message, {
        variant: "success",
        autoHideDuration: 3000,
      });
      dispatch(resetSuperAdminStatus());
      setIsSubscriptionPopupOpen(false);
      setYear(null);
      setNote(null);
      setSelectedFiles([]);
      setActionEffect(null);
      dispatch(companyDetails(companyId));
    } else if (updateActionStatus.status === STATUS.ERROR) {
      enqueueSnackbar(
        updateActionStatus?.data.message ||
          "We couldn't process your request. Please try again later.",
        { variant: "error", autoHideDuration: 3000 }
      );
      dispatch(resetSuperAdminStatus());
    }
  }, [updateActionStatus, dispatch, enqueueSnackbar]);

  const getConfirmation = () => {
    return (
      <Box className={classes.popUp}>
        <CloseIcon onClick={handleClosePopup} className={classes.closeIcon} />
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          {extendedSub
            ? `Are you sure you want to reactivate Subscription for company ${companyName}?`
            : `Are you sure you want to extend the Subscription period to 30 days
          for company ${companyName}?`}
        </Typography>
        <div className={classes.buttonContainer}>
          <CeroButton
            className={classes.buttonPrimary}
            variant="contained"
            onClick={extendedSub ? reactivateSubscription : extendSubscription}
            buttonText="Yes"
          />
          <CeroButton
            className={classes.buttonSecondary}
            variant="outlined"
            onClick={() => setIsPopupOpen(false)}
            buttonText="No"
          />
        </div>
      </Box>
    );
  };
  const years = [
    {
      value: 1,
      key: 1,
    },
    {
      value: 2,
      key: 2,
    },
    {
      value: 3,
      key: 3,
    },
    {
      value: 4,
      key: 4,
    },
    {
      value: 5,
      key: 5,
    },
    {
      value: 6,
      key: 6,
    },
    {
      value: 7,
      key: 7,
    },
    {
      value: 8,
      key: 8,
    },
    {
      value: 9,
      key: 9,
    },
    {
      value: 10,
      key: 10,
    },
  ];
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newFiles = files.map((file) => ({
      name: file.name,
      size: `${(file.size / 1024).toFixed(2)} KB`,
      file,
    }));
    setSelectedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };
  const handleButtonClick = (action) => {
    setAction(action);
    if (action === "extendSubscription") {
      setTitle("Confirm Extend Subscription");
      setSubTitle(
        `You're about to extend the subscription for ${companyName}.`
      );
    } else if (action === "activateGracePeriod") {
      setTitle("Confirm Grace Period Activation");
      setSubTitle(
        `You're about activate a 30-day grace period for ${companyName}.`
      );
    } else if (action === "cancelSubscription") {
      setTitle("Confirm Cancel Subscription");
      var tmpStr = `Are you sure you want to cancel the subscription for ${companyName}?`;
      if (subStatus === "active")
        tmpStr += "Please choose when the cancellation should take effect:";
      setSubTitle(tmpStr);
    } else if (action === "extendGracePeriod") {
      setTitle("Confirm Grace Period Activation");
      setSubTitle(
        `You're about activate a 30-day grace period for ${companyName}.`
      );
    } else if (action === "grandReadOnly") {
      setTitle("Confirm Read only Mode Activation");
      setSubTitle(
        `You're about activate a 30-day Read-Only mode for ${companyName}.`
      );
    } else if (action === "renewSubscription") {
      setTitle("Confirm Subscription Renewal");
      setSubTitle(`You're about to renew the subscription for ${companyName}.`);
    } else if (action === "extendReadOnly") {
      setTitle("Confirm Read only Mode Activation");
      setSubTitle(
        `You're about activate a 30-day Read-Only mode for ${companyName}.`
      );
    }
    setIsSubscriptionPopupOpen(true);
  };

  const checkConfirmButton = () => {
    if (action === "extendSubscription" || action === "renewSubscription") {
      return !note || !year;
    } else if (action === "cancel") {
      return !note || !actionEffect;
    } else {
      return !note;
    }
  };

  const confirmActionUpdate = () => {
    var updateAction = "";
    if (action === "activateGracePeriod")
      updateAction = "activate_grace_period";
    else if (action === "cancelSubscription") updateAction = "cancel";
    else if (action === "extendGracePeriod")
      updateAction = "extend_grace_period";
    else if (action === "grandReadOnly")
      updateAction = "activate_read_only_mode";
    else if (action === "renewSubscription")
      updateAction = "renew_subscription";
    else if (action === "extendReadOnly")
      updateAction = "extend_read_only_mode";
    else if (action === "extendSubscription")
      updateAction = "extend_subscription";

    dispatch(
      superAdminSubscriptionUpdate(
        companyId,
        updateAction,
        note,
        year,
        actionEffect,
        selectedFiles
      )
    );
  };

  const getExtendSubPopup = () => {
    return (
      <Box className={classes.popUp}>
        <CloseIcon onClick={handleClosePopup} className={classes.closeIcon} />
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          {subTitle}
        </Typography>
        {(action === "extendSubscription" ||
          action === "renewSubscription") && (
          <div className={classes.yearDiv}>
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Select the number of years
            </Typography>
            <CeroSelect
              required
              id="years"
              name="years"
              label="years"
              fullWidth
              options={years}
              selectedValue={year}
              onChange={(e) => setYear(e.target.value)}
              classes={{ root: classes.yearInput }}
            />
          </div>
        )}
        {action === "cancelSubscription" && subStatus === "active" && (
          <div className={classes.cancelDiv}>
            <label className={classes.radioGroup}>
              <input
                type="radio"
                name="cancelGroup"
                value="cancel_immediately"
                checked={actionEffect === "cancel_immediately"}
                onChange={(event) => setActionEffect(event.target.value)}
              />
              Cancel Immediately
            </label>
            <label className={classes.radioGroup}>
              <input
                type="radio"
                name="cancelGroup"
                value="cancel_after_subscription_period"
                checked={actionEffect === "cancel_after_subscription_period"}
                onChange={(event) => setActionEffect(event.target.value)}
              />
              Cancel After Subscritpion Period
            </label>
          </div>
        )}
        <div className={classes.noteDiv}>
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            Notes:
          </Typography>
          <CeroInput
            required
            id="note"
            name="note"
            label="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            classes={{
              container: classes.textAreaContainer,
              input: classes.noteInput,
            }}
          />
        </div>
        <div className={classes.fileDiv}>
          <Button
            variant="contained"
            className={classes.uploadButton}
            component="label"
            startIcon={<AttachmentOutlinedIcon />}
          >
            Attach Documents
            <input type="file" hidden multiple onChange={handleFileChange} />
          </Button>
          <Box sx={{ display: "flex", gap: "8px" }}>
            {selectedFiles?.map((file, index) => (
              <CeroUploadedFile
                key={index}
                fileName={file.name}
                fileSize={file.size}
                onRemove={() => handleRemoveFile(index)}
              />
            ))}
          </Box>
        </div>
        <div className={classes.extendButtonContainer}>
          <CeroButton
            className={classes.buttonSecondary}
            variant="outlined"
            onClick={() => setIsSubscriptionPopupOpen(false)}
            buttonText="Cancel"
          />
          <CeroButton
            className={classes.buttonPrimary}
            variant="contained"
            onClick={() => confirmActionUpdate()}
            buttonText="Confirm"
            disabled={checkConfirmButton()}
          />
        </div>
      </Box>
    );
  };

  return (
    <>
      <Card className={classes.card}>
        <CardContent>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Subscription Details</Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box className={classes.statusBox}>
                <Typography>Subscription Status:</Typography>
                <Typography
                  className={classes.activeStatus}
                  style={{
                    color:
                      props?.companyData?.subscription_status === "active"
                        ? "green"
                        : props?.companyData?.subscription_status ===
                          "in_grace_period"
                        ? "orange"
                        : props?.companyData?.subscription_status ===
                          "read_only_mode"
                        ? "blue"
                        : props?.companyData?.subscription_status === "inactive"
                        ? "grey"
                        : props?.companyData?.subscription_status ===
                          "cancelled"
                        ? "red"
                        : "black",
                  }}
                >
                  {props?.companyData?.subscription_status
                    ? props?.companyData?.subscription_status
                        .split("_")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" ")
                    : "NA"}
                </Typography>
              </Box>
              <CeroButton
                className={classes.buttonSecondary}
                variant="outlined"
                onClick={() => navigate(`/companies-subscription/${companyId}`)}
                buttonText="View logs"
              />
            </div>
          </div>
          <CeroItemPair
            title="License Type:"
            value={
              props?.companyData?.license_type
                ? extendedSub
                  ? `${props?.companyData?.license_type} (Extended Subscription 30 days)`
                  : props?.companyData?.license_type
                : "NA"
            }
            classes={{
              container: classes.infoContainer,
              title: classes.title,
              value: classes.value,
            }}
          />
          <CeroItemPair
            title="Subscription Start Date:"
            value={
              props?.companyData?.subscription_start_date
                ? props?.companyData?.subscription_start_date
                : "NA"
            }
            classes={{
              container: classes.infoContainer,
              title: classes.title,
              value: classes.value,
            }}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            <CeroItemPair
              title="Subscription End Date:"
              value={
                props?.companyData?.subscription_end_date
                  ? props?.companyData?.subscription_end_date
                  : "NA"
              }
              classes={{
                container: classes.infoContainer,
                title: classes.title,
                value: classes.value,
              }}
            />
            {extendedSub ? (
              <Typography className={classes.subValue}>
                Extended Subscription -{" "}
                {props?.companyData?.extended_subscription_days_left} days left
                !
              </Typography>
            ) : subStatus === "active" ? (
              <Typography className={classes.remainingValue}>
                {props?.companyData?.days_left < 30
                  ? `${props?.companyData?.days_left} days left!`
                  : ""}
              </Typography>
            ) : (
              <></>
            )}
          </div>
          {props?.companyData?.grace_period &&
            (subStatus === "in_grace_period" || subStatus === "active") && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <CeroItemPair
                  title="Grace Period Validity:"
                  value={
                    props?.companyData?.grace_period
                      ? props?.companyData?.grace_period
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.title,
                    value: classes.value,
                  }}
                />
              </div>
            )}

          {props?.companyData?.read_only_mode_period &&
            subStatus === "read_only_mode" && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <CeroItemPair
                  title="Read Only Mode Validity:"
                  value={
                    props?.companyData?.read_only_mode_period
                      ? props?.companyData?.read_only_mode_period
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.title,
                    value: classes.value,
                  }}
                />
              </div>
            )}
          {subStatus === "active" && (
            <div>
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Extend Subscription"
                onClick={() => handleButtonClick("extendSubscription")}
              />
              {subDaysLeft < 30 && !props?.companyData?.grace_period && (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Activate Grace Period"
                  onClick={() => handleButtonClick("activateGracePeriod")}
                />
              )}
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Cancel Subscription"
                onClick={() => handleButtonClick("cancelSubscription")}
              />
            </div>
          )}
          {subStatus === "in_grace_period" && (
            <div>
              {props?.companyData?.is_subscription_end ? (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Renew Subscription"
                  onClick={() => handleButtonClick("renewSubscription")}
                />
              ) : (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Extend Subscription"
                  onClick={() => handleButtonClick("extendSubscription")}
                />
              )}
              {canExtendGrace && (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Extend Grace Period"
                  onClick={() => handleButtonClick("extendGracePeriod")}
                />
              )}
              {canExtendReadOnly && (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Grant Read Only"
                  onClick={() => handleButtonClick("grandReadOnly")}
                />
              )}
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Cancel Subscription"
                onClick={() => handleButtonClick("cancelSubscription")}
              />
            </div>
          )}

          {subStatus === "read_only_mode" && (
            <div>
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Renew Subscription"
                onClick={() => handleButtonClick("renewSubscription")}
              />
              {canExtendGrace && (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Activate Grace Period"
                  onClick={() => handleButtonClick("activateGracePeriod")}
                />
              )}
              {canExtendReadOnly && (
                <CeroButton
                  className={classes.buttonSubcription}
                  variant="outlined"
                  buttonText="Extend Read Only"
                  onClick={() => handleButtonClick("extendReadOnly")}
                />
              )}
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Cancel Subscription"
                onClick={() => handleButtonClick("cancelSubscription")}
              />
            </div>
          )}
          {subStatus === "inactive" && (
            <div>
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Renew Subscription"
                onClick={() => handleButtonClick("renewSubscription")}
              />
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Activate Grace Period"
                onClick={() => handleButtonClick("activateGracePeriod")}
              />
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Grant Read Only"
                onClick={() => handleButtonClick("grandReadOnly")}
              />
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Cancel Subscription"
                onClick={() => handleButtonClick("cancelSubscription")}
              />
            </div>
          )}
          {subStatus === "cancelled" && (
            <div>
              <CeroButton
                className={classes.buttonSubcription}
                variant="outlined"
                buttonText="Renew Subscription"
                onClick={() => handleButtonClick("renewSubscription")}
              />
            </div>
          )}
          {/* {extendedSub && (
            <>
              <CeroItemPair
                title="Disable edit access?"
                value={
                  <div className={classes.radioBox}>
                    <FormControlLabel
                      control={
                        <Radio
                          id="disableEditAccess"
                          name="disableEditAccess"
                          checked={editAccessDisabled === true}
                          onClick={onEdit}
                          className={classes.radio}
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </div>
                }
                classes={{
                  container: classes.editContainer,
                  title: classes.title,
                  value: classes.value,
                }}
              />
              <CeroItemPair
                title="Duration for Read only Access"
                value={
                  <div className={classes.radioBox}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={selectedValue === 3}
                          value="3"
                          id="durationReadOnly"
                          name="durationReadOnly"
                          onChange={handleChange}
                          className={classes.radio}
                          onClick={() => {
                            readOnlyAccess(3);
                          }}
                        />
                      }
                      label="3 months"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={selectedValue === 6}
                          value="6"
                          id="durationReadOnly"
                          onChange={handleChange}
                          name="durationReadOnly"
                          className={classes.radio}
                          onClick={() => {
                            readOnlyAccess(6);
                          }}
                        />
                      }
                      label="6 months"
                      labelPlacement="end"
                    />
                  </div>
                }
                classes={{
                  container: classes.editContainer,
                  title: classes.title,
                  value: classes.value,
                }}
              />
            </>
          )}
          {props?.companyData?.days_left < 30 && (
            <CeroButton
              buttonText={
                extendedSub
                  ? "Reactivate Subscription"
                  : "Extent Subscription Period"
              }
              className={classes.buttonPrimary}
              disabled={
                props?.companyData?.days_left !== 0 &&
                props?.companyData?.days_left < 30
              }
              onClick={() => setIsPopupOpen(true)}
            />
          )} */}
        </CardContent>
      </Card>
      <CeroPopUp
        primaryPopUp={{
          open: isPopupOpen,
          onClose: { handleClosePopup },
          content: getConfirmation(),
          header: {
            title: extendedSub
              ? "Reactivate Subscription"
              : "Extend Subscription Period",
          },
        }}
        classes={{ dialog: classes.dialog }}
      />
      <CeroPopUp
        primaryPopUp={{
          open: isSubscriptionPopupOpen,
          onClose: { handleClosePopup },
          content: getExtendSubPopup(),
          header: {
            title: title,
          },
        }}
        classes={{
          dialog: classes.subDialog,
          headerTitle: classes.headerTitle,
        }}
      />
    </>
  );
};

export default CustomerManagement;
